/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';

export const selectSearch             = ({devicefiles: {search}}) => search;
export const selectExportFiles        = ({devicefiles: {showExportFile}}) => showExportFile;
export const selectDownloadFileType   = ({devicefiles: {downloadFileType}}) => downloadFileType;
export const downloadFile             = ({devicefiles: {downloadFiles}}) => downloadFiles;
export const selectExportReleaseNotes = ({devicefiles: {showExportReleaseNote}}) => showExportReleaseNote;
export const downloadReleaseNote      = ({devicefiles: {downloadReleaseNotes}}) => downloadReleaseNotes;

export const deviceFileSearch = createDeepEqualSelector(
  [selectSearch], (search) => search
);

export const deviceFileIsFiles = createSelector(
  [selectExportFiles], (showExportFile) => showExportFile
);

export const deviceFileIsReleaseNotes = createSelector(
  [selectExportReleaseNotes], (showExportReleaseNote) => showExportReleaseNote
);

export const deviceFileDownloadFileType = createDeepEqualSelector(
  [selectDownloadFileType], (downloadFileType) => downloadFileType
);

export const deviceFileDownloadFiles = createDeepEqualSelector(
  [downloadFile], (downloadFiles) => downloadFiles
);

export const deviceFileReleaseNotes = createDeepEqualSelector(
  [downloadReleaseNote], (downloadReleaseNotes) => downloadReleaseNotes
);

const selectAudit            = ({devicefiles: {audit}}) => audit;
const auditNotification      = state => selectAudit(state).selected;
const showAuditNotification  = state => selectAudit(state).isEditing;
const selectedAuditRecord    = state => selectAudit(state).auditRecord;
const showAuditChangesDialog = state => selectAudit(state).showChangesDialog;

export const deviceFileIsAuditNotifications = createSelector(
  [showAuditNotification], (isEditing) => isEditing
);

export const deviceFileAuditDialogChanges = createSelector(
  [showAuditChangesDialog], (showChangesDialog) => showChangesDialog
);

export const deviceFileAuditNotifications = createDeepEqualSelector(
  [auditNotification], (selected) => selected
);

export const deviceFileIsAuditRecord = createDeepEqualSelector(
  [selectedAuditRecord], (auditRecord) => auditRecord
);

// Device Files Grid Reselectors
const selectDeviceFilesGrid = ({devicefiles: {grid}}) => grid?.columnState;

export const deviceFilesGridSelector = createDeepEqualSelector(
  selectDeviceFilesGrid, grid => grid
);

// Device Files Destroy Reselectors
const selectDeviceFilesDestroy            = ({devicefiles: {destroy}}) => destroy;
const selectDeviceFilesDestroyShowDialog  = state => selectDeviceFilesDestroy(state).showDialog;
const selectDeviceFilesDestroySelected    = state => selectDeviceFilesDestroy(state).selected;
const selectDeviceFilesDestroyResult      = state => selectDeviceFilesDestroy(state).result;
const selectDeviceFilesDestroyShowLoading = state => selectDeviceFilesDestroy(state).loading;
const selectDeviceFilesDestroyError       = state => selectDeviceFilesDestroy(state).error;

export const deviceFilesDestroySelectedSelector = createDeepEqualSelector(
  selectDeviceFilesDestroySelected, selected => selected
);

export const deviceFilesDestroyResultSelector = createDeepEqualSelector(
  selectDeviceFilesDestroyResult, result => result
);

export const deviceFilesDestroyShowDialogSelector = createSelector(
  selectDeviceFilesDestroyShowDialog, (showDialog: boolean) => showDialog
);

export const deviceFilesDestroyShowLoadingSelector = createSelector(
  selectDeviceFilesDestroyShowLoading, (loading: boolean) => loading
);

export const deviceFilesDestroyErrorSelector = createDeepEqualSelector(
  selectDeviceFilesDestroyError, error => error
);

const selectGridColumnState  = ({devicefiles: {grid}}) => grid?.columnState;
const selectAdd              = ({devicefiles: {add}}) => add;
const selectAddResult        = state => selectAdd(state).result;

const selectEdit             = ({devicefiles: {edit}}) => edit;
const selectEditResult       = state => selectEdit(state).result;

const selectAddConfig        = ({devicefiles: {addModbusConfig}}) => addModbusConfig;
const selectAddConfigResult  = state => selectAddConfig(state).result;

const selectEditConfig       = ({devicefiles: {editModbusConfig}}) => editModbusConfig;
const selectEditConfigResult = state => selectEditConfig(state).result;

const selectEditPegWizard    = ({devicefiles: {editPegWizard}}) => editPegWizard;
const editPegWizardSelected  = state => selectEditPegWizard(state).selected;

export const deviceFilesGridColumnStateSelector = createDeepEqualSelector(selectGridColumnState,
  columnState => columnState
);

export const devicFilesAddResultSelector = createDeepEqualSelector(selectAddResult,
  result => result
);

export const devicFilesEditResultSelector = createDeepEqualSelector(selectEditResult,
  result => result
);

export const devicFilesEditConfigResultSelector = createDeepEqualSelector(selectEditConfigResult,
  result => result
);

export const devicFilesAddConfigResultSelector = createDeepEqualSelector(selectAddConfigResult,
  result => result
);

export const selectPegWizardEditFile = createDeepEqualSelector(editPegWizardSelected,
  selected => selected
);
